// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database"; 
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyDQezjFF3TrcP7McZUGnR6FlWtukH3mV1g",
//   authDomain: "postpaldev-b0be2.firebaseapp.com",
//   projectId: "postpaldev-b0be2",
//   storageBucket: "postpaldev-b0be2.appspot.com",
//   messagingSenderId: "932688719065",
//   appId: "1:932688719065:web:be9c8a4a29da04bdc862c8",
//   measurementId: "G-ED14P6Z81R",
// };
const firebaseConfigLive = {
  apiKey: "AIzaSyBJ6Qs8Ccc-M8IJMShXrzqd2NVBBp4dRvk",
  authDomain: "postpal-7afa7.firebaseapp.com",
  databaseURL: "https://postpal-7afa7-default-rtdb.firebaseio.com",
  projectId: "postpal-7afa7",
  storageBucket: "postpal-7afa7.appspot.com",
  messagingSenderId: "297187601349",
  appId: "1:297187601349:web:e38317b12b2228b24bb9ac",
  measurementId: "G-VTFRK92E73"
};

// Initialize Firebase
const app = initializeApp(firebaseConfigLive);
// const app = initializeApp(firebaseConfig);
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider('6LeDspQpAAAAAEClwfc3db7UKzHC_SaZIVTY77mv'),
  isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
});
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const dbRealtime = getDatabase(app);
export const storage = getStorage(app);